import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

import { Actions, Mutations } from '@/store/enums/StoreEnums';

@Module
export default class MenuModule extends VuexModule {
	isMenuOpen = false;
	/**
	 * Get authentification errors
	 * @returns array
	 */
	get getIsMenuOpen() {
		return this.isMenuOpen;
	}

	@Action
	[Actions.TOGGLE_IS_MENU_OPEN]() {
		this.context.commit(Mutations.TOGGLE_IS_MENU_OPEN)
	}
	@Mutation
	[Mutations.TOGGLE_IS_MENU_OPEN]() {
		this.isMenuOpen = !this.isMenuOpen;
	}
}
